import styled from 'styled-components';
import { space } from 'styled-system';
import TypographyStyles from '../base/typographyStyles';

const WysiwygStyles = styled.div``;

const WysiwygToolbarStyles = styled.div`
  ${space}

  display: flex;
  flex-wrap: wrap;
  margin: 0 -${props => props.theme.space[1]};
`;

const WysiwygToolbarItemStyles = styled.div`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  white-space: nowrap;
  margin: ${props => props.theme.space[1]};
  & + & {
  }

  ${TypographyStyles.TextStyles} {
    margin-right: ${props => props.theme.space[1]};
  }
`;

WysiwygStyles.ToolbarStyles = WysiwygToolbarStyles;
WysiwygStyles.ToolbarItemStyles = WysiwygToolbarItemStyles;

export default WysiwygStyles;
